import React, { useEffect, useRef } from 'react';
import { CSVLink } from 'react-csv';
import { LinkProps as CSVLinkProps } from 'react-csv/components/Link';

// We need this workaround to make filename work.
// https://github.com/react-csv/react-csv/issues/47#issuecomment-859555722
export const CsvDownloadAsLink: React.FC<CSVLinkProps> = ({
  ref,
  ...props
}) => {
  const btnRef = useRef<HTMLSpanElement>(null);

  useEffect(() => btnRef.current?.click(), [btnRef]);

  return (
    <CSVLink {...props}>
      <span ref={btnRef} />
    </CSVLink>
  );
};
